module.exports = __webpack_public_path__ + "static/media/jordi_pug.b799232e.png";